












import { Vue, Component } from 'vue-property-decorator';
import { Emit, Prop } from '@samclick-commons';

@Component
export default class SamclickInput extends Vue {
    @Prop({ default: '' }) private value!: string;

    @Emit('input')
    input(e:any) {
      return e;
    }

    @Emit('change')
    change(e:any) {
      return e;
    }

    @Emit('blur')
    blur(e:any) {
      return e;
    }

    get defaultAttrs() {
      return {
        size: 'small',
      };
    }

    get overrideAttrs() {
      return Object.assign(this.defaultAttrs, this.$attrs);
    }
}
